import React from 'react';
interface PhotoReview {
  image: string;
  alt: string;
}
const photos: PhotoReview[] = [{
  image: 'https://cdn.magicpatterns.com/uploads/2dPvsbRjTyNxAZwDWpgLAS/ChatGPT_Image_Jul_24,_2026,_09_46_00_PM.png',
  alt: 'Reseña gráfica de pablomm_7 — Manual del Pivote Moderno en el campo'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/hQ2ytJ2fsPUbuYYQgwq6ut/ChatGPT_Image_Jul_24,_2026,_09_46_46_PM.png',
  alt: 'Reseña gráfica de marcosg_14 — Manual del Pivote Moderno en el vestuario'
}];
export function ReviewPhotoCarousel() {
  return <section className="mb-12" aria-label="Reseñas gráficas de jugadores" data-id="element-192" data-mp="1q0ra35zl4j6v">
      <div className="-mx-4 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-193" data-mp="24wyrxznit8iz">
        {photos.map((photo, index) => <article key={index} className="w-[72vw] max-w-[280px] flex-none snap-center overflow-hidden rounded-2xl border border-gray-200 shadow-lg" data-id="element-194" data-mp="3g8zm5u35lp64" data-mpi={index}>
            <img src={photo.image} alt={photo.alt} className="block aspect-[9/16] w-full object-cover object-top" data-id="element-195" data-mp="hal3a3kkzhj9" />
          </article>)}
      </div>
      <p className="mt-1 text-center text-xs font-semibold text-gray-500" data-id="element-196" data-mp="ra268d8g7hbj">
        Desliza para ver más reseñas →
      </p>
    </section>;
}